import { DuringContractListPage } from "@/features/match/pages/DuringContractList";
import React from "react";

const DuringContractList = () => {
  return <DuringContractListPage />;
};

export default DuringContractList;
